import React from "react";

const Loader = () => {
  return (
    <div className="loadingContainer flex perfectCenter">
      <p className="loader" />
    </div>
  );
};

export default Loader;
